export default __webpack_public_path__ + "static/media/gymIcon.6bae8acc.svg";